"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _utils = require("../../utils");
var _linkFieldSrc = require("../../lib/linkFieldSrc");
var _imageSrc = require("../../lib/imageSrc");
var _richTextField = require("../../lib/richTextField");
var _lodash = require("lodash");
var _CTAButton = _interopRequireDefault(require("../../components/CTAButton"));
var _constants = require("../../utils/constants");
var _dateFns = require("date-fns");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 *  A react component to create a ContactCard
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} A contact card
 */
function ModalWindow(props) {
  if (!props.rendering.fields) {
    return null;
  }
  var extractedFields = (0, _utils.extractFieldsFn)(props);
  var {
    linkUrl,
    linkTarget,
    linkAlt
  } = (0, _linkFieldSrc.linkFieldSrc)(extractedFields.ctaRedirect.fields.Link.value);
  var contentClassName = extractedFields.HeaderAlignment.value === 'left' ? 'align' : 'default';
  var [show, setShowModal] = (0, _react.useState)(true);
  var handleModalHide = () => OnModalClose();
  var handleModalClose = () => OnModalClose();
  var modalStorageKey = _constants.MODAL_Display.replace('[id]', props.rendering.dataSource.slice(1, -1));
  (0, _react.useEffect)(() => {
    var wasClosedByUser = window.localStorage.getItem(modalStorageKey);
    var goodToOpen = (0, _lodash.isNull)(wasClosedByUser) ? true : (0, _dateFns.isPast)(new Date(parseInt(wasClosedByUser))) || (0, _dateFns.isSameDay)(new Date(parseInt(wasClosedByUser)), new Date());
    if (goodToOpen) setShowModal(true);else setShowModal(false);
  }, [modalStorageKey]);
  var OnModalClose = () => {
    var numberOfDays = (0, _lodash.isNull)(extractedFields.Recurrence) ? 0 : parseInt(extractedFields.Recurrence.fields.NumberItem.value);
    if (numberOfDays !== 0) window.localStorage.setItem(modalStorageKey, (0, _dateFns.getTime)((0, _dateFns.addDays)(new Date(), numberOfDays)));
    setShowModal(false);
  };
  var HeaderLogo = () => {
    if ((0, _lodash.isEmpty)(extractedFields.Logo.value)) return null;else {
      var logoImg = (0, _imageSrc.imageHref)(extractedFields.Logo.value);
      if ((0, _lodash.isEmpty)(logoImg)) return null;else {
        var imgAlignClass = extractedFields.LogoAlignment.value === 'left' ? 'align-self-left' : 'align-self-center';
        return /*#__PURE__*/_react.default.createElement("picture", {
          className: imgAlignClass
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: logoImg,
          alt: extractedFields.Logo.value.alt
        }));
      }
    }
  };
  var FooterCTA = props => {
    if (props.acceptCTA) {
      return /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
        buttonType: props.ButtonType.value,
        label: props.Text.value,
        dataId: 'accept',
        icon: props.ctaIcon.value,
        iconDirection: props.ctaIconPlacement.value,
        onClick: () => handleModalHide()
      });
    } else {
      return /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
        buttonType: props.ButtonType.value,
        label: props.Text.value,
        dataId: 'reject',
        href: linkUrl,
        target: linkTarget,
        linkAlt: linkAlt,
        icon: props.ctaIcon.value,
        iconDirection: props.ctaIconPlacement.value
      });
    }
  };
  var FooterModal = () => {
    var ctaAlignment = (0, _lodash.get)(extractedFields.ctaAlignment, 'value', 'center');
    if (extractedFields.ctaAcceptPlacement.value === 'left') {
      return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Footer, {
        className: "modal-cta-".concat(ctaAlignment)
      }, /*#__PURE__*/_react.default.createElement(FooterCTA, _extends({}, extractedFields.ctaAccept.fields, {
        acceptCTA: true
      })), /*#__PURE__*/_react.default.createElement(FooterCTA, extractedFields.ctaRedirect.fields));
    } else {
      return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Footer, {
        className: "modal-cta-".concat(ctaAlignment)
      }, /*#__PURE__*/_react.default.createElement(FooterCTA, extractedFields.ctaRedirect.fields), /*#__PURE__*/_react.default.createElement(FooterCTA, _extends({}, extractedFields.ctaAccept.fields, {
        acceptCTA: true
      })));
    }
  };
  return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: show,
    onHide: handleModalHide,
    centered: true,
    contentClassName: contentClassName,
    className: 'gatekeeper-modal',
    title: extractedFields.Header.value
  }, /*#__PURE__*/_react.default.createElement(HeaderLogo, null), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    title: extractedFields.Header.value,
    onClose: () => handleModalClose()
  }), !(0, _lodash.isEmpty)(extractedFields.BodyContent.value) && /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, (0, _richTextField.parseHTML)(extractedFields.BodyContent)), /*#__PURE__*/_react.default.createElement(FooterModal, null), !(0, _lodash.isEmpty)(extractedFields.Disclosure.value) && /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-disclosure caption"
  }, (0, _richTextField.parseHTML)(extractedFields.Disclosure)));
}
var _default = exports.default = ModalWindow;